import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingsNavigation from "@Shared/components/settings/settings-navigation";
import PageHeader from "@Shared/components/general/page-header";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import FaqTab from "./faq/components/faq-tab";
import ApplicationDisclaimers from "./disclaimers/components/application-disclaimers";
import ApplicationVisibility from "./application-form/components/application-visibility";
import ThemesTab from "./themes/components/themes-tab";
import AccountContainer from "./account/components/account-container";
import NotificationsContainer from "@Broker/@Modules/settings/notifications/components/notifications-container";
import { LOAD_BROKERAGE_OVERRIDES, VALIDATE_SYNCED_EMAIL } from "./store/settings-actions";
import { SET_THEME_PREVIEW } from "./store/settings-mutations";
import { mapActions, mapMutations, mapState } from "vuex";
import permissionsMixin from "./mixins/permissions-mixin";
import settingsMixin from "./mixins/settings-mixin";
import { LOAD_PERSONAL_DETAILS } from "../main/store/account/account-actions";
import SettingsLoader from "./settings-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEmpty } from "lodash";
import ResetVisibilitySettingsModal from "./application-form/components/reset-visibility-modal";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PersonalSettingsContainer",
  title() {
    return this.$t("sidebar.sections.personalSettings");
  },
  components: {
    SimpleButton,
    PageHeader,
    SettingsNavigation,
    ThemesTab,
    FaqTab,
    ApplicationDisclaimers,
    ApplicationVisibility,
    AccountContainer,
    NotificationsContainer,
    SettingsLoader,
    ResetVisibilitySettingsModal
  },
  mixins: [permissionsMixin, settingsMixin],
  props: {
    tab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      currentTab: "",
      saving: false,
      resetting: false,
      savingStatus: false,
      resettingStatus: false,
      allowSave: false,
      settingsType: "personal-settings",
      //Needed for permissions mixin
      nylasAccount: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["isOnThemePreviewMode", "overrides"])), mapState("ApplicationStore", {
    isDefaultSchema(state) {
      return state.customizationSchema.isDefaultSchema;
    }
  })), {}, {
    tabs() {
      return [{
        key: "account",
        label: this.$t("settings.tabs.account"),
        component: "account-container"
      }, {
        key: "notifications",
        label: this.$t("settings.tabs.notifications"),
        component: "notifications-container"
      }, {
        key: "theme",
        label: this.$t("settings.tabs.theme"),
        disabled: this.getTabDisabledOption({
          key: "theme",
          override: "overrideStyle"
        }),
        component: "themes-tab"
      }, {
        key: "application-form",
        label: this.$t("settings.tabs.applicationForm"),
        disabled: this.getTabDisabledOption({
          key: "application-form",
          override: "overrideForm"
        }),
        component: "application-visibility"
      }, {
        key: "disclaimers",
        label: this.$t("settings.tabs.disclaimers"),
        disabled: this.getTabDisabledOption({
          key: "disclaimers",
          override: "overrideForm"
        }),
        component: "application-disclaimers"
      }, {
        key: "faq",
        label: this.$t("settings.tabs.FAQ"),
        disabled: this.getTabDisabledOption({
          key: "faq",
          override: "overrideFaq"
        }),
        component: "faq-tab"
      }];
    },
    allowReset() {
      return !this.isDefaultSchema;
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Personal Settings - visited");
  },
  async mounted() {
    this.setInitialCurrentTab();
    if (!(isEmpty(this.overrides) || this.$route.query.code || this.$route.name === "personal-settings")) return; // There's no need to load
    this.loading = true;
    const syncResult = await this.validateSyncedEmail();
    await this.LOAD_PERSONAL_DETAILS();
    if (isEmpty(this.overrides)) await this.LOAD_BROKERAGE_OVERRIDES();
    this.loading = false;
    if (syncResult.grantId) {
      showToast("error", "emailAlreadyConnected");
      this.nylasAccount = syncResult;
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), mapActions("SettingsStore", [LOAD_BROKERAGE_OVERRIDES, VALIDATE_SYNCED_EMAIL])), mapMutations("SettingsStore", [SET_THEME_PREVIEW])), {}, {
    handleTabChange(tab) {
      this.currentTab = tab;
      this.allowSave = false;
      Amplitude.logEvent(`Personal Settings - ${tab} visited`);
    },
    startSaving() {
      this.saving = true;
    },
    showResetVisibilitySettingsModal() {
      this.$refs.resetVisibilitySettingsModal.showModal();
    },
    startResetting() {
      this.resetting = true;
    },
    async finishSaving(savingStatus) {
      this.saving = false;
      this.savingStatus = savingStatus;
      this.allowSave = false;
      await this.LOAD_PERSONAL_DETAILS();
    },
    finishResetting(resettingStatus) {
      this.resetting = false;
      this.resettingStatus = resettingStatus;
    },
    handleAllowSave(canSave) {
      this.allowSave = canSave;
    },
    handlePreviewTheme() {
      this.SET_THEME_PREVIEW({
        previewMode: true,
        previewModeSource: "personal-settings"
      });
    },
    async validateSyncedEmail() {
      const {
        code
      } = this.$route.query;
      if (!code) return;
      const syncResult = await this.VALIDATE_SYNCED_EMAIL(code);
      this.$router.replace({
        path: "/personal-settings/account/email-preferences"
      });
      return syncResult;
    },
    setInitialCurrentTab() {
      const queryTab = this.$route.query.tab;
      const metaTab = this.$route.meta.tab;
      this.currentTab = queryTab || metaTab || this.tabs[0].key;
      Amplitude.logEvent(`Personal Settings - ${this.currentTab} visited`);
    }
  })
});